import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceForm } from './service-form/service.form';
import { Service } from '../service.model';
import { AngularFireAuth } from '@angular/fire/auth';
import { switchMap, map, take } from 'rxjs/operators';
import { MyServicesService } from './my-services.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { UIControlService } from 'src/app/shared/uicontrol.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-my-services-layout',
  templateUrl: './my-services-layout.component.html',
  styleUrls: ['./my-services-layout.component.scss']
})
export class MyServicesLayoutComponent implements OnInit {
  public services: Array<ServiceForm> = [];
  public loading = true;
  private userId: string;

  @ViewChild('fabTooltip') public fabTooltip: MatTooltip;

  constructor(
    private myServicesService: MyServicesService,
    private fireAuth: AngularFireAuth,
    private storage: AngularFireStorage,
    private ui: UIControlService
  ) {}

  public ngOnInit(): void {
    this.fireAuth.user
      .pipe(
        map(fireAuthUser => {
          this.userId = fireAuthUser.uid;
          return this.myServicesService.getMyServicesCollection(fireAuthUser);
        }),
        switchMap(collection => collection.snapshotChanges()),
        take(1)
      )
      .subscribe(myServices => {
        for (const service of myServices) {
          this.services.push(
            new ServiceForm(
              service.payload.doc.id,
              service.payload.doc.data(),
              this.myServicesService,
              this.storage
            )
          );
        }

        if (myServices.length === 0) {
          this.fabTooltip.show();
        }
        this.loading = false;
      });
  }

  public addService(): void {
    const newService = new Service();
    newService.userId = this.userId;
    this.services.push(
      new ServiceForm(null, newService, this.myServicesService, this.storage)
    );
  }

  public deleteService(service: ServiceForm): void {
    this.services.splice(this.services.indexOf(service), 1);
  }
}
